import SelfInitComponent from "General/global-js/SelfInitComponent";
import { MetanavSearch } from "./metanavsearch.js";
import { Helperfn } from "General/global-js/helpers";
import "./metanavsearch-desktop.scss";
import "./metanavsearch-mainnavtablet.scss";
import "./metanavsearch-tablet.scss";
import "./metanavsearch-mobile.scss";

class MetaNavigationSearchComponent extends SelfInitComponent {
  constructor(selector) {

    super(selector);
  }

  init() {
    Helperfn.init();
    MetanavSearch.init();
  }
}
new MetaNavigationSearchComponent("#headerMetaNavigationSearch");
